import ImageOptimizer from '@/components/image-optimizer';
import { formatKoreanDate } from '@/lib/date';
import {
  convertRouteFromBoardType,
  slugify,
  storyArticleListPathSegment,
} from '@/lib/utils';
import { ArticleEntity, ArticleType } from '@/services/types/article.type';
import Link from 'next/link';

interface Props extends ArticleEntity {
  showDate?: boolean;
}
export default function EventCard({
  id,
  title,
  startDatetime,
  endDatetime,
  viewDatetime,
  thumbPath,
  board,
  showDate = true,
}: Props) {
  return (
    <Link
      href={
        convertRouteFromBoardType(board) +
        '/' +
        storyArticleListPathSegment(board.type) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="flex flex-col gap-7 bg-white">
        <div className="flex gap-4">
          <div className="desktop:h-[220px] relative aspect-[27/16] w-full flex-shrink-0 overflow-hidden rounded-lg">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
              // sizes="(max-width: 768px) 100px, 120px"
            />
          </div>
        </div>
        <div className="desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between flex flex-col gap-4">
          <div className="desktop:h-full">
            <div className="text-level-2 typo-28 desktop:typo-26 desktop:text-level-1 truncate font-extrabold">
              {title}
            </div>
          </div>
          <div className="text-level-5 typo-18 font-semibold">
            {showDate
              ? board?.type == ArticleType.EVENT
                ? formatKoreanDate(startDatetime) +
                  ' ~ ' +
                  (endDatetime ? formatKoreanDate(endDatetime) : '상시진행')
                : formatKoreanDate(viewDatetime)
              : board.name}
          </div>
        </div>
      </div>
    </Link>
  );
}
